import { Head } from '@unhead/react';

export const ProductlaneScript = () => {
    return (
        <Head>
            <script>
                {`
                    ((w) => {
                        const P = (w.Productlane = { queue: {} });
                        ['set', 'open', 'close', 'toggle', 'on', 'off', 'init'].forEach((m) => {
                            P[m] = ((n) =>
                                function () {
                                    P.queue[n] = { args: arguments };
                                })(m);
                        });
                    })(window);

                    Productlane.init({
                        widgetKey: '132880a3-20d9-4b76-9fc4-91f457d643c5',
                        theme: {
                            '--text-color-primary': '#193643',
                            '--text-color-primary-dark': '#FFFFFF',
                            '--text-color-secondary': '#466573',
                            '--text-color-secondary-dark': '#9CA3AF',
                            '--text-color-highlight': '#0659FF',
                            '--text-color-highlight-dark': '#0659FF',
                            '--background-color-primary': '#FFFFFF',
                            '--background-color-primary-dark': '#193643',
                            '--background-color-secondary': '#F8FBFD',
                            '--background-color-secondary-dark': '#466573',
                            '--border-color-primary': '#E2EFF5',
                            '--border-color-primary-dark': '#466573',
                        },
                    });
                `}
            </script>
            <script
                async
                defer
                crossOrigin="anonymous"
                src="https://widget.productlane.com/latest.productlane-widget.min.js"
            />
        </Head>
    );
};
